import {Alert, Button, Card, CardBody, CardHeader, Typography,} from "@material-tailwind/react";
import React, {useEffect, useState} from "react";
import {UserWithdrawalGrid} from "./user_grid";
import {UserWithdrawalForm} from "./user_form";
import {getPersonWithdrawal} from "../../services/wallet/wallet";
import {CardFooterPaginator} from "../system/cardFooterPaginator";
import {PaginateContext} from "../../context/paginate";

export function UserWithdrawalManagement() {

  const [withdrawals, setUserWithdrawals] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [gridRowCount, setGridRowCount] = useState(10);
  const [gridCurrentPage, setGridCurrentPage] = useState(1);
  const [gridSelectedRow, setGridSelectedRow] = useState(null);
  const [gridTotalRowCount, setGridTotalRowCount] = useState(0);
  const [sortBy, setSortBy] = useState("id")
  const [sortType, setSortType] = useState(false);
  const [from, setFrom] = useState((gridCurrentPage - 1) * gridRowCount + 1);
  const [to, setTo] = useState((gridCurrentPage) * gridRowCount);
  const [lastDataRefresh, setLastDataRefresh] = useState(null);

  useEffect(() => {
    if ((gridCurrentPage) * gridRowCount <= gridTotalRowCount) {
      setTo((gridCurrentPage) * gridRowCount)
    } else {
      setTo(gridTotalRowCount)
    }
    if (gridTotalRowCount === 0) {
      setFrom(0)
    } else {
      setFrom((gridCurrentPage - 1) * gridRowCount + 1)
    }
  }, [gridCurrentPage, gridRowCount, gridTotalRowCount]);

  async function getData(paginate) {
    const result = await getPersonWithdrawal(paginate);
    if (result.status === 200) {
      const {withdrawalList, total_count} = result.data;
      setUserWithdrawals(withdrawalList || []);
      setGridTotalRowCount(total_count)
    }
  }

  useEffect(() => {
    // const data = filter()
    const paginate = new URLSearchParams({
      "sort_by": sortBy,
      "sort_type": sortType === false ? "DESC" : "ASC",
      "limit": parseInt(gridRowCount),
      "offset": (parseInt(gridCurrentPage) - 1) * parseInt(gridRowCount),
    }).toString()

    getData(paginate)
  }, [lastDataRefresh, gridCurrentPage, gridRowCount, sortBy, sortType]);

  return (
    <PaginateContext.Provider value={{
      setSortBy: setSortBy,
      sortType: sortType,
      setSortType: setSortType,
      active: gridCurrentPage,
      setActive: setGridCurrentPage,
      totalRows: gridTotalRowCount,
      rowsCount: gridRowCount,
      setRowsCount: setGridRowCount,
      from: from,
      to: to,
    }}>
      <div className="">
        {modalOpen && <UserWithdrawalForm withdrawal={gridSelectedRow} open={modalOpen} setOpen={setModalOpen}
                                          setLastDataRefresh={setLastDataRefresh}
                                          setGridSelectedRow={setGridSelectedRow}/>}
        <Card className="pt-8">
          <CardHeader floated={true} shadow={false} className="flex flex-col rounded-none">
            <div className="mb-8 flex flex-row items-center justify-between gap-8">
              <Typography variant="h5" color="blue-gray">درخواست‌های برداشت</Typography>
              <Button onClick={() => {
                setGridSelectedRow(null);
                setModalOpen(true);
              }} variant="outlined">جدید</Button>
            </div>
            <div className="flex-row w-fit justify-items-center">
              <Alert className="w-full" variant="outlined">
                <Typography className="w-full">
                  مباشر گرامی، درخواست های برداشت شما، پس از تائید از سوی پلتفرم مباشر (ظرف 24 الی 72 ساعت کاری) به
                  شماره
                  حساب ارائه شده از سوی شما واریز خواهد شد.
                </Typography>
              </Alert>
            </div>
          </CardHeader>
          <CardBody className="overflow-x-auto w-full">
            <UserWithdrawalGrid
              withdrawals={withdrawals}
              setModalOpen={setModalOpen}
              setSelectedRow={setGridSelectedRow}
            />
          </CardBody>
          <CardFooterPaginator/>
        </Card>
      </div>
    </PaginateContext.Provider>
  )
    ;
}